import { render, staticRenderFns } from "./TechUpdate.vue?vue&type=template&id=f0a2486c&lang=pug&"
import script from "./TechUpdate.vue?vue&type=script&lang=js&"
export * from "./TechUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports